export const styles = {
  page: {
    pt: { xs: 1.5, md: 2 },
    pb: 0,
    px: { xs: 0, md: 1 },
  },
  paper: {
    maxWidth: 820,
    mx: 'auto',
    px: { xs: 2.5, sm: 4, md: 5 },
    pt: { xs: 2.5, sm: 3 },
    pb: { xs: 2.5, sm: 3 },
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
  },
  pageTitle: {
    mb: 2,
    fontSize: { xs: '1.75rem', sm: '2rem' },
    fontWeight: 700,
    lineHeight: 1.25,
    color: 'text.primary',
  },
  lead: {
    mb: 2,
    fontWeight: 600,
    fontSize: '1.05rem',
    lineHeight: 1.65,
  },
  body: {
    fontSize: '1rem',
    lineHeight: 1.7,
    color: 'text.primary',
  },
  majorSection: {
    mt: 5,
  },
  majorSectionTitle: {
    mb: 1,
    fontSize: { xs: '1.45rem', sm: '1.55rem' },
    fontWeight: 700,
    lineHeight: 1.3,
    color: 'text.primary',
  },
  section: {
    mt: 4.5,
  },
  sectionTitle: {
    mb: 1,
    fontSize: '1.2rem',
    fontWeight: 700,
    lineHeight: 1.35,
    color: 'text.primary',
  },
  sectionDivider: {
    mb: 2,
    borderColor: 'divider',
  },
  bulletList: {
    m: 0,
    pl: 2.75,
  },
  bulletItem: {
    mb: 1.25,
    pl: 0.25,
  },
  bulletLabel: {
    fontWeight: 700,
  },
  callout: {
    mt: 2.5,
    px: 2,
    py: 1.5,
    borderLeft: '4px solid',
    borderColor: 'primary.main',
    bgcolor: 'action.hover',
    borderRadius: 1,
  },
  calloutText: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.6,
  },
  practicesList: {
    mb: 1.5,
  },
  practiceItem: {
    alignItems: 'flex-start',
    py: 0.85,
  },
  practiceIcon: {
    minWidth: 36,
    mt: 0.35,
  },
  note: {
    mt: 1.5,
    px: 2,
    py: 1.25,
    bgcolor: 'grey.100',
    borderRadius: 1,
  },
  noteText: {
    fontSize: '0.95rem',
    lineHeight: 1.6,
    color: 'text.secondary',
  },
  closing: {
    mt: 3,
    px: 2.5,
    py: 2.25,
    borderRadius: 1.5,
    bgcolor: 'grey.50',
    border: '1px solid',
    borderColor: 'divider',
  },
};
